import { get, post } from './http'

const topicPath = '/circle/frontend/topic/'
const TOPIC = {
    // 获取话题通用配置
    getTopicBase: (params) => {
      return get(`${topicPath}config`, params)
    },

    // 查询全部话题分类
    getAllTopicCategory: (params) => {
      return get(`${topicPath}category/list`, params)
    },
    // 分页查询推荐的话题
    getRecommendedTopic: (params) => {
      return get(`${topicPath}list/recommended`, params)
    },
    // 分页查询话题(last)
    getLastTopic: (params) => {
      return get(`${topicPath}list`, params)
    },
    // 分页查询我关注的话题(last)
    getFollowTopic: (params) => {
      return get(`${topicPath}list/follow`, params)
    },
    // 分页查询指定分类下的话题
    getCategoryTopic: (params) => {
      return get(`${topicPath}list/category`, params)
    },
    // 搜索话题
    getSearchTopic: (params) => {
      return get(`${topicPath}page`, params)
    },
    // 获取话题详情接口
    getTopicDetail: (params) => {
      return get(`${topicPath}get`, params)
    },
    // 分页获取话题下的帖子
    getTopicThread: (params) => {
      return get(`${topicPath}thread/list`, params)
    },
    // 新增关注话题
    addFollowTopic: (params) => {
      params.needAuth = true
      return post(`${topicPath}follow/create`, params)
    },
    // 取消关注话题
    cancelFollowTopic: (params) => {
      params.needAuth = true
      return post(`${topicPath}follow/cancel`, params)
    },
}


export default TOPIC